import { GoldRule, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

export default function Slide10Tesi() {
  return (
    <SlideShell theme="ivory" testid="slide-10-la-tesi">
      <SlideBody>
        <Reveal>
          <Micro tone="ivory">09 · La Tesi</Micro>
        </Reveal>
        <h2 className="mt-8 max-w-5xl font-serif text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-[64px]">
          <MaskedLine delay={0.15}>NON CERCARE SOLO</MaskedLine>
          <MaskedLine delay={0.28}>NUOVE PRENOTAZIONI.</MaskedLine>
        </h2>
        <Reveal delay={0.55}>
          <p className="mt-7 max-w-2xl font-serif text-2xl italic leading-snug text-[#997A15] sm:text-3xl">
            Massimizza il valore delle prenotazioni che hai già.
          </p>
        </Reveal>
        <Reveal delay={0.8} className="mt-14 flex items-center gap-6">
          <GoldRule tone="ivory" delay={0.8} />
          <span className="font-sans text-lg font-bold uppercase tracking-[0.22em] text-[#0B152C] sm:text-2xl">
            Every stay. More value.
          </span>
        </Reveal>
        <Reveal delay={0.95} className="mt-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#64748B]">
            Ipotesi commerciale · validata dal caso La Balena Blu, non un dato universale
          </p>
        </Reveal>
      </SlideBody>
    </SlideShell>
  );
}
